import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getDesignPanelPreviewStateMap,
  getPartToPreviewStateMap,
} from '@wix/editor-elements-preview-utils';
import type { IFastGalleryDefinition } from '../documentManagement/FastGallery.definition';
import type { FastGalleryPreviewMapperProps } from '../FastGallery.types';
import type { IFastGalleryContainerCarmiProps } from './FastGallery.mapper';
import { props as viewerPropsMapper } from './FastGallery.mapper';

const props = composeMapper<
  FastGalleryPreviewMapperProps,
  IFastGalleryDefinition,
  IFastGalleryContainerCarmiProps
>()(
  viewerPropsMapper,
  {
    add: ['compPreviewState'],
  },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { compPreviewState } = deps;

    const designPanelPreviewStateMap =
      getDesignPanelPreviewStateMap(compPreviewState);

    return {
      ...viewerProps,
      trackClicksAnalytics: false,
      partToPreviewStateMap: getPartToPreviewStateMap(
        designPanelPreviewStateMap,
      ),
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
